"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var _componentUtils = require("../../common/componentUtils");
const _excluded = ["title", "img", "list", "advantageList", "buttonList"];
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const TabPanel = _tpmProductIntl.Tab.TabPanel;
const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  const handledItemsList = items.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      _ref2$title = _ref2.title,
      scaneTitle = _ref2$title === void 0 ? '' : _ref2$title,
      img = _ref2.img,
      _ref2$list = _ref2.list,
      list = _ref2$list === void 0 ? [] : _ref2$list,
      _ref2$advantageList = _ref2.advantageList,
      advantageList = _ref2$advantageList === void 0 ? [] : _ref2$advantageList,
      _ref2$buttonList = _ref2.buttonList,
      buttonList = _ref2$buttonList === void 0 ? [] : _ref2$buttonList,
      other = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    const handleList = list.map(item => item.text);
    const handledAdvantageList = advantageList === null || advantageList === void 0 ? void 0 : advantageList.map((activityItem, index) => {
      const _ref3 = activityItem || {},
        _ref3$title = _ref3.title,
        title = _ref3$title === void 0 ? '' : _ref3$title,
        _ref3$itemList = _ref3.itemList,
        itemList = _ref3$itemList === void 0 ? [] : _ref3$itemList;
      const handleList = itemList.map(item => item.text);
      return {
        title,
        data: handleList
      };
    });
    const handledBtnList = buttonList === null || buttonList === void 0 ? void 0 : buttonList.map((activityItem, index) => {
      const _ref4 = activityItem || {},
        _ref4$label = _ref4.label,
        label = _ref4$label === void 0 ? '' : _ref4$label,
        _ref4$href = _ref4.href,
        href = _ref4$href === void 0 ? '' : _ref4$href;
      const btnExtendProps = {
        'report-event': 'click_Scene_button',
        'report-ext1': index,
        'report-ext2': label || '',
        'report-ext3': href || '',
        'target': '_blank'
      };
      return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        icon: true,
        align: "center",
        type: index === 0 ? 'primary' : 'weak',
        href: href
      }, btnExtendProps), label);
    });
    const convertToFragment = elements => /*#__PURE__*/React.createElement(React.Fragment, null, elements.map((element, index) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, element)));
    return _objectSpread(_objectSpread({}, other), {}, {
      layout: 'horizontal',
      title: scaneTitle ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
        html: scaneTitle
      }) : '',
      id: `id${index + 1}`,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      list: handleList,
      advantage: handledAdvantageList,
      btns: handledBtnList.length > 0 ? convertToFragment(handledBtnList) : null
    });
  });
  return {
    porintId,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    bg,
    items: handledItemsList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    var _heroData$items;
    const heroData = formatAdvantageCommon(data, {
      domains
    });
    console.log('SceneHorizontal--', heroData);
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: (heroData === null || heroData === void 0 ? void 0 : heroData.porintId) || '',
      className: "gems-materials-qci__newUI-sceneHorizontal"
    }, (0, _reportUtil.reportShow)(['show_newUI_SceneHorizontal', componentKey, (heroData === null || heroData === void 0 ? void 0 : heroData.title) || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      title: heroData === null || heroData === void 0 ? void 0 : heroData.title,
      bg: heroData === null || heroData === void 0 ? void 0 : heroData.bg
    }, (heroData === null || heroData === void 0 ? void 0 : heroData.items) && (heroData === null || heroData === void 0 ? void 0 : (_heroData$items = heroData.items) === null || _heroData$items === void 0 ? void 0 : _heroData$items.length) > 0 && /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: (heroData === null || heroData === void 0 ? void 0 : heroData.items) || []
    }, ((heroData === null || heroData === void 0 ? void 0 : heroData.items) || []).map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: item.id,
      key: index
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Scene, item))))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}